import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { mergeMapTo } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

/*
  Generated class for the FcmProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FcmProvider {
  currentMessage = new BehaviorSubject(null);
  
    constructor(
      private angularFireMessaging: AngularFireMessaging) {
      /*this.angularFireMessaging.messaging.subscribe(
        (_messaging) => {
          _messaging.onMessage = _messaging.onMessage.bind(_messaging);
          _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
        }
      ) */
    }
  
    /**
     * update token in firebase database
     * 
     * @param userId userId as a key 
     * @param token token as a value
     */
    updateToken(userId, token) {
      // we can change this function to request our backend service
    }
  
    /**
     * request permission for notification from firebase cloud messaging
     * 
     * @param userId userId
     */
    requestPermission() {
      this.angularFireMessaging.getToken.subscribe(
        (token) => {
          console.log("Token FCM: "+token);
          //this.updateToken(userId, token);
        },
        (err) => {
          console.error('Unable to get permission to notify.', err);
        }
      )
      this.angularFireMessaging.requestToken.subscribe(
        (token) => {
          console.log("Token FCM: "+token);
          //this.updateToken(userId, token);
        },
        (err) => {
          console.error('Unable to get permission to notify.', err);
        }
      );
    }
  
    /**
     * hook method when new notification received in foreground
     */
    receiveMessage() {
      this.angularFireMessaging.messages.subscribe(
        (payload) => {
          console.log("new message received. ", payload);
          alert(JSON.stringify(payload));
          this.currentMessage.next(payload);
        })
    }
  }



// WEBPACK FOOTER //
// ./src/providers/fcm/fcm.ts